import { useNavigate } from 'react-router-dom';
import { theme } from '../theme';
import { useIsMobile } from '../hooks/useMediaQuery';

function RecargarResultado() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  return (
    <main style={{ padding: isMobile ? '2rem 1rem' : '3rem 1.5rem', display: 'flex', justifyContent: 'center' }}>
      <div style={{
        backgroundColor: theme.colors.surface,
        borderRadius: '14px',
        border: `1px solid ${theme.colors.border}`,
        padding: isMobile ? '1.75rem 1.25rem' : '2.5rem',
        width: '100%',
        maxWidth: '420px',
        boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
        <h1 style={{ color: theme.colors.primary, fontSize: '1.5rem', marginBottom: '0.6rem' }}>
          Tu pago ha sido recibido
        </h1>
        <p style={{ color: theme.colors.textMuted, fontSize: '0.95rem', lineHeight: '1.7', marginBottom: '2rem' }}>
          El saldo se actualizará en breve. Si realizaste el pago correctamente,
          tu cuenta quedará activa automáticamente.
        </p>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '11px 32px',
            backgroundColor: theme.colors.primary,
            color: theme.colors.background,
            border: 'none',
            borderRadius: '7px',
            fontSize: '1rem',
            fontWeight: '700',
            cursor: 'pointer',
          }}
        >
          Volver al inicio
        </button>
      </div>
    </main>
  );
}

export default RecargarResultado;
